import { render, staticRenderFns } from "./common.vue?vue&type=template&id=dc50450c&scoped=true&"
import script from "./common.vue?vue&type=script&lang=ts&"
export * from "./common.vue?vue&type=script&lang=ts&"
import style0 from "./common.vue?vue&type=style&index=0&id=dc50450c&lang=scss&scoped=true&"
import style1 from "./common.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc50450c",
  null
  
)

export default component.exports